import { Box } from '@mui/material';
import React from 'react';
import { ArrayField, Datagrid, FunctionField, TextField, useRecordContext } from 'react-admin';

import { EducationCenterType, HospitalDepartment } from 'src/components/Employees/types';
import { getValueOrPlaceholder } from 'src/utils';

const DepartmentsInfoTab: React.FC = () => {
    const records = useRecordContext<EducationCenterType>();

    if (!records) return null;

    const getHospitalDepartmentTypedRow = (rowData: any): HospitalDepartment => {
        return rowData as HospitalDepartment;
    };

    return (
        <ArrayField source="hospitalDepartments">
            <Datagrid
                bulkActionButtons={false}
                sx={{
                    '& .RaDatagrid-table': { tableLayout: 'fixed' },
                    '& .RaDatagrid-rowCell:first-of-type, & .RaDatagrid-headerCell:first-of-type': {
                        width: 200,
                        minWidth: 200
                    }
                }}>
                <FunctionField
                    source="departmentName"
                    label="Назва відділеня"
                    render={(row: any) => getValueOrPlaceholder(getHospitalDepartmentTypedRow(row)?.departmentName)}
                />
                <FunctionField
                    source="hospitalName"
                    label="Назва лікарні"
                    render={(row: any) => getValueOrPlaceholder(getHospitalDepartmentTypedRow(row)?.hospitalName)}
                />
            </Datagrid>
        </ArrayField>
    );
};

export default DepartmentsInfoTab;
